import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

const initialState = {
  data: {},
};
export const slice = createSlice({
  name: "lastedDeviceForceSync",
  initialState: _.cloneDeep(initialState),
  reducers: {
    setLastedDeviceForceSync: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setLastedDeviceForceSync } = slice.actions;

export default slice.reducer;
